// extracted by mini-css-extract-plugin
module.exports = {"Score":"Score_Score__3h_n1","EmptyScore":"Score_EmptyScore__3qQft"};